const helpers = {}

helpers.setTitle = title => {
  document.title = title ? `${title}-郭氏電影學術分享會` : '郭氏電影學術分享會'
}

export default helpers